import WildHeartForm from './WildHeartForm.js';

export default WildHeartForm;
